import { useQuery } from '@tanstack/react-query';
import { devStandardsApi } from '../api/devStandardsApi';

/**
 * GET /api/eraf/standards?page&size (버전 목록)
 * queryKey: ['dev-standards', 'list', { page, size }]
 */
export function useStandardsList(page = 0, size = 20) {
  return useQuery({
    queryKey: ['dev-standards', 'list', { page, size }],
    queryFn: () => devStandardsApi.listVersions(page, size),
    staleTime: 30_000,
  });
}
